import cn from "classnames";
import { AddressField, Datetime, Field } from "components/shared/form";
import ForwardingOrderInfo from "components/shared/forwardingOrderInfo";
import { paths } from "helpers/paths";
import { ymEvent } from "helpers/system";
import { requiredField } from "helpers/validators";
import React, { useState } from "react";

export default function PointForwardingOrder(props) {
    const { isLastPoint, addressSelected, profile, setForwardingData, forwardingOrderConfig } = props;

    const [show, setShow] = useState(!!props.forwardingOrder);

    if (!isLastPoint || !addressSelected) {
        return null;
    }

    const toggleShow = () => {
        ymEvent("RequestReturnFlight");
        const newValue = !show;
        setShow(newValue);
        if (newValue) {
            setForwardingData({});
        } else {
            setForwardingData(undefined);
        }
    };
    const forwardingOrder = {
        toPoint: undefined,
        contactPersonFullName: profile.fullName,
        contactPersonPhoneNumber: profile.phoneNumber,
        ...props.forwardingOrder,
    };
    const setValue = ({ name, value }) => setForwardingData({ ...(forwardingOrder ?? {}), [name]: value });

    const renderField = (name) => (
        <Field
            {...forwardingOrderConfig[name]}
            required
            validators={[requiredField]}
            labelWrapper="col-12 col-form-label col-form-label-sm text-muted"
            fieldWrapper="col-12"
            value={forwardingOrder[name]}
            onChange={setValue}
        />
    );

    const renderDateField = (name) => (
        <Datetime
            {...forwardingOrderConfig[name]}
            required
            validators={[requiredField]}
            labelWrapper="col-12 col-form-label col-form-label-sm text-muted"
            fieldWrapper="col-12"
            value={forwardingOrder[name]}
            onChange={setValue}
        />
    );

    const anyDirection = (
        <div
            className="col-form-label-sm d-inline-block"
            onClick={() => setValue({ name: "toPoint", value: forwardingOrder.toPoint ? undefined : {} })}
        >
            <div className={cn("checkbox d-inline-block", { "checkbox--checked": !forwardingOrder.toPoint })} />
            &nbsp;
            <div className="d-inline-block checkbox__text">Любое направление</div>
        </div>
    );

    const renderAddressField = (name) => (
        <AddressField
            {...forwardingOrderConfig[name]}
            disabled={!forwardingOrder.toPoint}
            inputBottomText={anyDirection}
            required={forwardingOrder.toPoint}
            validators={forwardingOrder.toPoint ? [requiredField] : []}
            labelWrapper="col-12 col-form-label col-form-label-sm text-muted"
            fieldWrapper="col-12"
            geopoint={forwardingOrder[name]}
            value={forwardingOrder[name]}
            onChange={setValue}
        />
    );

    return (
        <>
            <div className="row form-group">
                <div className="col-auto offset-sm-4 offset-md-3">
                    <div className="btn btn-sm btn-brand d-flex align-items-center" onClick={toggleShow}>
                        <div className={cn("checkbox d-inline-block", { "checkbox--checked": show })} />
                        &nbsp;
                        <div className="d-inline-block checkbox__text">Запросить обратный рейс</div>
                        &nbsp;
                        <ForwardingOrderInfo />
                    </div>
                </div>
            </div>
            {show && (
                <div className="row">
                    <div className="col-sm-8 col-md-9 offset-sm-4 offset-md-3">
                        <div className="card card-body mb-3">
                            {renderAddressField("toPoint")}
                            {renderDateField("fromPointPlanEnterTime")}
                            {renderField("contactPersonFullName")}
                            {renderField("contactPersonPhoneNumber")}
                            {props.forwardingOrder?.externalId && (
                                <div>
                                    <a
                                        className="btn btn-sm btn-link"
                                        href={paths.forwardingTruckerPlanning}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        Просмотреть отправленный запрос
                                    </a>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
